import {store} from "../store";
import {settingsPageSlice} from "./settingsPageSlice";
import {SettingsPageSection} from "./settingsPageTypes";

export const settingsPageStore = {
  // State modifiers
  setSelectedSection: (section: SettingsPageSection) => {
    store.dispatch(settingsPageSlice.actions.selectedSectionReducer({selectedSection: section}));
  },

  // Getters
  getSelectedSection: () => settingsPageSlice.selectors.selectedSectionSelector(store.getState()),
};

